exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addPartner{background:#fff;margin:20px;width:400px;padding-bottom:50px!important}.btn{margin-left:100px}", ""]);

// exports
